import React, { useEffect, useState } from 'react';
import styles from './3SCReviewPhase.module.css';

const ReviewPhaseStep3 = () => {
    const [questionnaireDate, setQuestionnaireDate] = useState(null);
    const todayDate = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format

    // Prevent double fetch in StrictMode/dev by using a ref flag
    const hasFetchedSubmissionStatus = React.useRef(false);
    useEffect(() => {
        if (hasFetchedSubmissionStatus.current) return;
        hasFetchedSubmissionStatus.current = true;
        const fetchSubmissionStatus = async () => {
            const token = localStorage.getItem('token');
            if (!token) {
                console.error('User is not logged in.');
                return;
            }

            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/threesc/submission-status/`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    const submittedAt = data.submitted_at.split('T')[0]; // Extract date only
                    setQuestionnaireDate(submittedAt);
                } else {
                    console.error('Failed to fetch submission status:', await response.json());
                }
            } catch (error) {
                console.error('Error fetching submission status:', error);
            }
        };

        fetchSubmissionStatus();
    }, []);

    return (
        <div className={styles.reviewPage}>
            <div className={styles.pendingContainer}>
                {/* --- Main Status Card --- */}
                <div className={styles.statusCard}>
                    <h2>Your 3SC Certificate is under review.</h2>
                    <p>Our team is verifying your submitted documents. This typically takes up to <strong>3 business days</strong>.</p>
                    <div className={styles.loader}></div>
                </div>

                {/* --- Progress History Card --- */}
                <div className={styles.historyCard}>
                    <h3>Your Progress</h3>
                    <table className={styles.historyTable}>
                        <thead>
                            <tr>
                                <th>Step Completed</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>✅ Questionnaire</td>
                                <td>{questionnaireDate || 'Loading...'}</td>
                            </tr>
                            <tr>
                                <td>✅ Document Submission</td>
                                <td>{todayDate}</td>
                            </tr>
                            <tr>
                                <td>⏳ Review</td>
                                <td>In Progress</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ReviewPhaseStep3;